import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectStepTripCancellationAndTripInterruption, makeSelectStepTripCancellationAndTripInterruptionErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';
import { makeSelectInsuredsList, makeSelectIsClaimForFieldEnabled } from '../../App/selectors';
import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
  Validate,
  ErrorMessage,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormTravelInterruption,
} from './actions';
import {
  emailMedicalTravelDocument,
  emailInterruptionDocument,
} from '../../FastCover/actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { AdditionalList } from './components/Additional';
// import { DelayInformationList } from './components/DelayInformation';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import AsyncButtonSendMail from '../../../components/AsyncButtonSendMail/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import HelpText from '../../../components/HelpText';
import TimePickerInput from '../../../components/TimePickerInput';
import { stepTripCancellationAndTripInterruptionExpenseLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import { required, checkDateOnly } from '../../../utils/validation/validator';
import { InsuredList } from './components/AddInsured';
import { TravelSupplierList } from './components/AddTravelSupplier';
import { makeSelectJSONVersion, makeSelectIsClaimGroupAllowed } from '../../App/selectors';
export class StepTripCancellationAndTripInterruption extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
      physicianEmail: false,
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.emailMeDocumentButton = _.uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  // Trip Interruption
  onInsuredTripInterruptionChange = (data) => {
    this.props.onFormDataChange('form.insuredsForInterruption', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onTripInterruptionChange = (data) => {
    this.props.onFormDataChange('form.lossInformationItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onSupplierTripInterruption = (data) => {
    this.props.onFormDataChange('form.travelSuppliersTravelInterruption', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  // Travel Cancellation
  onTravelCancellationItemsChange = (data) => {
    this.props.onFormDataChange('form.lossInformationItemsTravelCancellation', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onInsuredTravelCancellationChange = (data) => {
    this.props.onFormDataChange('form.insuredsTravelCancellation', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  // Trip Cancellation For Any Reason
  onTripCancellationForAnyReasonChange = (data) => {
    this.props.onFormDataChange('form.lossInformationItemsTripCancellationForAnyReason', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onInsuredTripCancellationForAnyReasonChange = (data) => {
    this.props.onFormDataChange('form.insuredsTripCancellationForAnyReason', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onSupplierTripCancellationForAnyReasonChange = (data) => {
    this.props.onFormDataChange('form.travelSuppliersTripCancellationForAnyReason', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const {
      tripCancellation,
      tripCancellationForAnyReason,
      travelInterruption,
    } = this.props.form;
    const isSelectBenefit = tripCancellation === 'true' || tripCancellationForAnyReason === 'true' || travelInterruption === 'true';
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleNext = () => {
    const {
      tripCancellation,
      tripCancellationForAnyReason,
      travelInterruption,
    } = this.props.form;
    const isSelectBenefit = tripCancellation === 'true' || tripCancellationForAnyReason === 'true' || travelInterruption === 'true';
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  handleReasonsForDelay = (propertyName) => (event) => {
    const { reasonsForDelay } = this.props.form;
    const reasons = !!reasonsForDelay && typeof reasonsForDelay.toJS === 'function'
      ? reasonsForDelay.toJS()
      : reasonsForDelay || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleReasonsForTripInterruption = (propertyName) => (event) => {
    const { reasonsForTripInterruption } = this.props.form;
    const reasons = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
      ? reasonsForTripInterruption.toJS()
      : reasonsForTripInterruption || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleReasonsForTripCancellation = (propertyName) => (event) => {
    const { reasonForTripCancellation } = this.props.form;
    const reasons = !!reasonForTripCancellation && typeof reasonForTripCancellation.toJS === 'function'
      ? reasonForTripCancellation.toJS()
      : reasonForTripCancellation || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleEmailMeButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.sendPhysicianEmail();
  };

  handleEmailInterruption = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.sendPhysicianEmailInterruption();
  };

  // Trip Cancellation
  renderInsuredsTravelCancellation() {
    const { insuredsTravelCancellation } = this.props.form;
    const newInsureds = this.appendIds(insuredsTravelCancellation);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <InsuredList
          data={newInsureds}
          onChange={this.onInsuredTravelCancellationChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderTravelCancellationAdditionalItems() {
    const { lossInformationItemsTravelCancellation } = this.props.form;
    const newLossInformationItems = this.appendIds(lossInformationItemsTravelCancellation);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled, jsonVersion } = this.props;
    const isReadOnly = submitted || isSummary;
    const enabledClaimSplitFeature = jsonVersion >= 17 && isClaimForFieldEnabled;
    return (
      <div>
        <AdditionalList
          data={newLossInformationItems}
          onChange={this.onTravelCancellationItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={enabledClaimSplitFeature}
        />
      </div>
    );
  }

  // Trip Cancellation For Any Reason
  renderForAnyReasonInformationItems() {
    const { lossInformationItemsTripCancellationForAnyReason } = this.props.form;
    const newDelayInformationItems = this.appendIds(lossInformationItemsTripCancellationForAnyReason);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled, jsonVersion } = this.props;
    const isReadOnly = submitted || isSummary;
    const enabledClaimSplitFeature = jsonVersion >= 17 && isClaimForFieldEnabled;
    return (
      <div>
        <AdditionalList
          data={newDelayInformationItems}
          onChange={this.onTripCancellationForAnyReasonChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={enabledClaimSplitFeature}
        />
      </div>
    );
  }

  renderInsuredsTripCancellationForAnyReason() {
    const { insuredsTripCancellationForAnyReason } = this.props.form;
    const newInsureds = this.appendIds(insuredsTripCancellationForAnyReason);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <InsuredList
          data={newInsureds}
          onChange={this.onInsuredTripCancellationForAnyReasonChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderTravelSupplierTripCancellationForAnyReason() {
    const { travelSuppliersTripCancellationForAnyReason } = this.props.form;
    const travelSuppliersTripCancellationForAnyReasons = !!travelSuppliersTripCancellationForAnyReason && typeof travelSuppliersTripCancellationForAnyReason.toJS === 'function'
      ? travelSuppliersTripCancellationForAnyReason.toJS()
      : travelSuppliersTripCancellationForAnyReason || [];
    const newSuppliers = this.appendIds(travelSuppliersTripCancellationForAnyReasons);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <TravelSupplierList
          data={newSuppliers}
          onChange={this.onSupplierTripCancellationForAnyReasonChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  // TripInterruption
  renderTravelInterruption() {
    const {
      travelInterruption,
      dateTripInterrupted,
      reasonForInterruption,
      nameOfPersonHavingSickness,
      dateOfBirth,
      relationshipToClaimant,
      dateSicknessOrInjuryBegan,
      dateEnded,
      natureOfSicknessOrInjury,
      fromDate,
      toDate,
      enableTimeInterruption,
      reasonsForTripInterruption,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, jsonVersion, isClaimGroupAllowed, isClaimForFieldEnabled } = this.props;
    const buttonEmailMeDisable = !!enableTimeInterruption && new Date().getTime() < enableTimeInterruption;
    const isReadOnly = submitted || isSummary;
    const reasonsForTripInterruptions = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
      ? reasonsForTripInterruption.toJS()
      : reasonsForTripInterruption || [];
    const newVersion = jsonVersion > 7;
    const enabledClaimSplitFeature = jsonVersion >= 17 && isClaimForFieldEnabled;
    const isReason2 = reasonsForTripInterruptions.includes('reasons2');
    const isReasons15 = reasonsForTripInterruptions.includes('reasons15');
    return (
      travelInterruption === 'true' && (
        <div>
          <div className={'ml-3'}>
            <div className={'col-sm-12 form-group'}>
              <Validate
                name="reasonsForTripInterruption"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={reasonsForTripInterruptions}
                fieldName={messages.reasonsForTripInterruption}
              >
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons1"
                    checked={reasonsForTripInterruptions.includes('reasons1')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons1} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons2"
                    checked={reasonsForTripInterruptions.includes('reasons2')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons2} />
                  </span>
                  {(isReason2 && newVersion) &&
                    <div>
                      <div className={'ml-2 row'}>
                        <div className={'col-sm-5 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.nameOfPersonHavingSickness} />
                          </PageSectionHeader>
                          <Textbox
                            name="nameOfPersonHavingSickness"
                            type="text"
                            onChange={this.handleChange('form.nameOfPersonHavingSickness')}
                            value={nameOfPersonHavingSickness}
                            disabled={isReadOnly}
                          />
                        </div>
                        <div className={'col-sm-3 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.dateOfBirth} />
                          </PageSectionHeader>
                          <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateOfBirth"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateOfBirth')}
                            value={dateOfBirth}
                          />
                        </div>
                        <div className={'col-sm-4 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.relationshipToClaimant} />
                          </PageSectionHeader>
                          <Textbox
                            name="relationshipToClaimant"
                            type="text"
                            onChange={this.handleChange('form.relationshipToClaimant')}
                            value={relationshipToClaimant}
                            disabled={isReadOnly}
                          />
                        </div>
                      </div>
                      <div className={'ml-2 row'}>
                        <div className={'col-sm-4 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.dateSicknessOrInjuryBegan} />
                          </PageSectionHeader>
                          <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateSicknessOrInjuryBegan"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateSicknessOrInjuryBegan')}
                            value={dateSicknessOrInjuryBegan}
                          />
                        </div>
                        <div className={'col-sm-4 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.dateEnded} />
                          </PageSectionHeader>
                          <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="dateEnded"
                            type="text"
                            onDayChange={this.handleDayChange('form.dateEnded')}
                            value={dateEnded}
                          />
                        </div>
                        <div className={'col-sm-4 form-group'}>
                        </div>
                      </div>
                      <div className={'ml-2 row'}>
                        <div className={'col-sm-12 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.natureOfSicknessOrInjury} />
                          </PageSectionHeader>
                          <TextArea
                            disabled={isReadOnly}
                            name="natureOfSicknessOrInjury"
                            type="text"
                            onChange={this.handleChange('form.natureOfSicknessOrInjury')}
                            value={natureOfSicknessOrInjury}
                            isSummary={isSummary}
                          />
                        </div>
                      </div>
                      <div className={'ml-2 row'}>
                        <div className={'col-sm-12 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.periodOfHospitalization} />
                          </PageSectionHeader>
                        </div>
                        <div className={'form-group col-sm-3'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.fromDate} />
                          </PageSectionHeader>
                          <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="fromDate"
                            type="text"
                            onDayChange={this.handleDayChange('form.fromDate')}
                            value={fromDate}
                          />
                        </div>
                        <div className={'form-group col-sm-3'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.toDate} />
                          </PageSectionHeader>
                          <DatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="toDate"
                            type="text"
                            onDayChange={this.handleDayChange('form.toDate')}
                            value={toDate}
                          />
                        </div>
                        <div className={'form-group col-sm-6'}>
                        </div>
                      </div>
                      <div className={'ml-2 row'}>
                        <div className={'form-group col-sm-7'}>
                          <HelpText>
                            On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                          </HelpText>
                        </div>
                        <div className={'form-group col-sm-5'}>
                          <AsyncButtonSendMail
                            id={this.emailMeDocumentButton}
                            className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                            disabled={buttonEmailMeDisable || isReadOnly}
                            loading={this.props.loading}
                            spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                            onClick={this.handleEmailInterruption}
                          >
                            Statement of Attending Physician
                          </AsyncButtonSendMail>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons3"
                    checked={reasonsForTripInterruptions.includes('reasons3')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons3} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons4"
                    checked={reasonsForTripInterruptions.includes('reasons4')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons4} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons5"
                    checked={reasonsForTripInterruptions.includes('reasons5')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons5} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons6"
                    checked={reasonsForTripInterruptions.includes('reasons6')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons6} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons7"
                    checked={reasonsForTripInterruptions.includes('reasons7')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons7} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons8"
                    checked={reasonsForTripInterruptions.includes('reasons8')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons8} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons9"
                    checked={reasonsForTripInterruptions.includes('reasons9')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons9} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons10"
                    checked={reasonsForTripInterruptions.includes('reasons10')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons10} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons11"
                    checked={reasonsForTripInterruptions.includes('reasons11')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons11} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons12"
                    checked={reasonsForTripInterruptions.includes('reasons12')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons12} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons13"
                    checked={reasonsForTripInterruptions.includes('reasons13')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons13} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons14"
                    checked={reasonsForTripInterruptions.includes('reasons14')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons14} />
                  </span>
                </div>
                <div className={'col-sm-12 form-group'}>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="reasons15"
                    checked={reasonsForTripInterruptions.includes('reasons15')}
                    onChange={this.handleReasonsForTripInterruption('form.reasonsForTripInterruption')}
                  />
                  <span>
                    <FormattedMessage {...messages.reasons15} />
                  </span>
                  {(isReasons15 && newVersion) &&
                    <div className={'ml-2 row'}>
                      <div className={'col-sm-12 form-group'}>
                        <Validate
                          name="reasonForInterruption"
                          validators={[required]}
                          group={this.validatorGroup}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          defaultValue={reasonForInterruption}
                          fieldName={messages.reasonForInterruption}
                        >
                          <TextArea
                            disabled={isReadOnly}
                            name="reasonForInterruption"
                            type="text"
                            onChange={this.handleChange('form.reasonForInterruption')}
                            value={reasonForInterruption}
                            isSummary={isSummary}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.reasonForInterruption}
                            />
                          </ErrorMessage>
                        </Validate>
                      </div>
                    </div>
                  }
                </div>
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.reasonsForTripInterruption}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          {newVersion &&
            <div className={'ml-1 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTripInterrupted"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateTripInterrupted}
                  fieldName={messages.dateTripInterrupted}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTripInterrupted"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateTripInterrupted')}
                    value={dateTripInterrupted}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripInterrupted}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripInterrupted}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
              </div>
            </div>
          }
          {(isClaimGroupAllowed && !enabledClaimSplitFeature) &&
            <div className={'ml-3 row'}>
              <div className={'col-sm-12'}>
                <HelpText>
                  The amount you claim below is PER MEMBER. It needs to be an EQUAL amount claimed, for each person you selected in the page "What Happened".
                  If you want to claim DIFFERENT amounts for each person, please create a SEPARATE CLAIM per person.
                </HelpText>
              </div>
            </div>
          }
          <div className={'ml-3 mt-3'}>
            <PageSectionHeader>
              <FormattedMessage
                {...(isClaimGroupAllowed ? messages.lossInformationPerPerson : messages.lossInformation)}
              />
            </PageSectionHeader>
            {this.renderTripInterruptionInformationItems()}
            {!newVersion &&
              <div className={'ml-2'}>
                <div className={'row'}>
                  <div className={'col-sm-4 form-group'}>
                    <Validate
                      name="dateTripInterrupted"
                      validators={[checkDateOnly, required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={dateTripInterrupted}
                      fieldName={messages.dateTripInterrupted}
                    >
                      <DatePicker
                        position={'bottom-start'}
                        disabled={isReadOnly}
                        name="dateTripInterrupted"
                        type="text"
                        onDayChange={this.handleDayChange('form.dateTripInterrupted')}
                        value={dateTripInterrupted}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.dateTripInterrupted}
                        />
                      </ErrorMessage>
                      <ErrorMessage for="checkDateOnly">
                        <FormattedMessage
                          {...messages.checkEventDate}
                          values={messages.dateTripInterrupted}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                  <div className={'col-sm-8 form-group'}>
                  </div>
                </div>
                <div className={'row'}>
                  <div className={'col-sm-12 form-group'}>
                    <Validate
                      name="includedInPackage"
                      validators={[required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={reasonForInterruption}
                      fieldName={messages.reasonForInterruption}
                    >
                      <TextArea
                        disabled={isReadOnly}
                        name="reasonForInterruption"
                        type="text"
                        onChange={this.handleChange('form.reasonForInterruption')}
                        value={reasonForInterruption}
                        isSummary={isSummary}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.reasonForInterruption}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                </div>
                <div className={'row'}>
                  <div className={'col-sm-5 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.nameOfPersonHavingSickness} />
                    </PageSectionHeader>
                    <Textbox
                      name="nameOfPersonHavingSickness"
                      type="text"
                      onChange={this.handleChange('form.nameOfPersonHavingSickness')}
                      value={nameOfPersonHavingSickness}
                      disabled={isReadOnly}
                    />
                  </div>
                  <div className={'col-sm-3 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.dateOfBirth} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateOfBirth"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateOfBirth')}
                      value={dateOfBirth}
                    />
                  </div>
                  <div className={'col-sm-4 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.relationshipToClaimant} />
                    </PageSectionHeader>
                    <Textbox
                      name="relationshipToClaimant"
                      type="text"
                      onChange={this.handleChange('form.relationshipToClaimant')}
                      value={relationshipToClaimant}
                      disabled={isReadOnly}
                    />
                  </div>
                </div>
                <div className={'row'}>
                  <div className={'col-sm-4 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.dateSicknessOrInjuryBegan} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateSicknessOrInjuryBegan"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateSicknessOrInjuryBegan')}
                      value={dateSicknessOrInjuryBegan}
                    />
                  </div>
                  <div className={'col-sm-4 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.dateEnded} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateEnded"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateEnded')}
                      value={dateEnded}
                    />
                  </div>
                  <div className={'col-sm-4 form-group'}>
                  </div>
                </div>
                <div className={'row'}>
                  <div className={'col-sm-12 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.natureOfSicknessOrInjury} />
                    </PageSectionHeader>
                    <TextArea
                      disabled={isReadOnly}
                      name="natureOfSicknessOrInjury"
                      type="text"
                      onChange={this.handleChange('form.natureOfSicknessOrInjury')}
                      value={natureOfSicknessOrInjury}
                      isSummary={isSummary}
                    />
                  </div>
                </div>
                <div className={'row'}>
                  <div className={'col-sm-12 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.periodOfHospitalization} />
                    </PageSectionHeader>
                  </div>
                  <div className={'form-group col-sm-3'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.fromDate} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="fromDate"
                      type="text"
                      onDayChange={this.handleDayChange('form.fromDate')}
                      value={fromDate}
                    />
                  </div>
                  <div className={'form-group col-sm-3'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.toDate} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="toDate"
                      type="text"
                      onDayChange={this.handleDayChange('form.toDate')}
                      value={toDate}
                    />
                  </div>
                  <div className={'form-group col-sm-6'}>
                  </div>
                </div>
                <div className={'row'}>
                  <div className={'form-group col-sm-7'}>
                    <HelpText>
                      On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                    </HelpText>
                  </div>
                  <div className={'form-group col-sm-5'}>
                    <AsyncButtonSendMail
                      id={this.emailMeDocumentButton}
                      className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                      disabled={buttonEmailMeDisable || isReadOnly}
                      loading={this.props.loading}
                      spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                      onClick={this.handleEmailInterruption}
                    >
                      Statement of Attending Physician
                    </AsyncButtonSendMail>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      )
    );
  }

  renderTripInterruptionInformationItems() {
    const { lossInformationItems } = this.props.form;
    const newDelayInformationItems = this.appendIds(lossInformationItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled, jsonVersion } = this.props;
    const isReadOnly = submitted || isSummary;
    const enabledClaimSplitFeature = jsonVersion >= 17 && isClaimForFieldEnabled;
    return (
      <div>
        <AdditionalList
          data={newDelayInformationItems}
          onChange={this.onTripInterruptionChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={enabledClaimSplitFeature}
        />
      </div>
    );
  }

  renderInsuredsTripInterruption() {
    const { insuredsForInterruption } = this.props.form;
    const newInsureds = this.appendIds(insuredsForInterruption);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <InsuredList
          data={newInsureds}
          onChange={this.onInsuredTripInterruptionChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderTravelSupplierTripInterruption() {
    const { travelSuppliersTravelInterruption } = this.props.form;
    const travelSuppliersTravelInterruptions = !!travelSuppliersTravelInterruption && typeof travelSuppliersTravelInterruption.toJS === 'function'
      ? travelSuppliersTravelInterruption.toJS()
      : travelSuppliersTravelInterruption || [];
    const newSuppliers = this.appendIds(travelSuppliersTravelInterruptions);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <TravelSupplierList
          data={newSuppliers}
          onChange={this.onSupplierTripInterruption}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  // Travel Cancellation
  renderTripCancellation() {
    const {
      tripCancellation,
      reasonForTripCancellation,
      areYouCancellingTheTripDueToMedicalReasons,
      dateTravelCancellation,
      reasonForTravelCancellation,
      nameOfPersonHavingSicknessTravelCancellation,
      dateOfBirthTravelCancellation,
      relationshipToClaimantTravelCancellation,
      dateSicknessOrInjuryBeganTravelCancellation,
      dateEndedTravelCancellation,
      natureOfSicknessOrInjuryTravelCancellation,
      fromDateTravelCancellation,
      toDateTravelCancellation,
      enableTimeTravelCancellation,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, jsonVersion, isClaimGroupAllowed, isClaimForFieldEnabled } = this.props;
    const buttonEmailMeDisable = !!enableTimeTravelCancellation && new Date().getTime() < enableTimeTravelCancellation;
    const isReadOnly = submitted || isSummary;
    const reasonForTripCancellations = !!reasonForTripCancellation && typeof reasonForTripCancellation.toJS === 'function'
      ? reasonForTripCancellation.toJS()
      : reasonForTripCancellation || [];
    const newVersion = jsonVersion > 7;
    const enabledClaimSplitFeature = jsonVersion >= 17 && isClaimForFieldEnabled;
    const isReason2 = reasonForTripCancellations.includes('reasons2');
    const isReason15 = reasonForTripCancellations.includes('reasons15');
    return (
      tripCancellation === 'true' && (
        <div>
          {!newVersion &&
            <div className={'ml-3 row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.areYouCancellingTheTripDueToMedicalReasons} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      checked={areYouCancellingTheTripDueToMedicalReasons === 'true'}
                      onChange={this.handleChange('form.areYouCancellingTheTripDueToMedicalReasons')}
                    />
                    <FormattedMessage {...messages.yes} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      checked={areYouCancellingTheTripDueToMedicalReasons === 'false'}
                      onChange={this.handleChange('form.areYouCancellingTheTripDueToMedicalReasons')}
                    />
                    <FormattedMessage {...messages.no} />
                  </OptionsContainer>
                </FlexBox>
              </div>
            </div>
          }
          {!newVersion &&
            <div className={'ml-3'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.insureds} />
              </PageSectionHeader>
              {this.renderInsuredsTravelCancellation()}
            </div>
          }
          {newVersion &&
            <div className={'ml-3'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="reasonsForTripCancellation"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={reasonForTripCancellations}
                  fieldName={messages.reasonsForTripCancellation}
                >
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons1"
                      checked={reasonForTripCancellations.includes('reasons1')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons1} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons2"
                      checked={reasonForTripCancellations.includes('reasons2')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons2} />
                    </span>
                    {isReason2 === true &&
                      <div className={'col-sm-12 form-group'}>
                        <div className={'ml-2 row'}>
                          <div className={'col-sm-5 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.nameOfPersonHavingSickness} />
                            </PageSectionHeader>
                            <Textbox
                              name="nameOfPersonHavingSicknessTravelCancellation"
                              type="text"
                              onChange={this.handleChange('form.nameOfPersonHavingSicknessTravelCancellation')}
                              value={nameOfPersonHavingSicknessTravelCancellation}
                              disabled={isReadOnly}
                            />
                          </div>
                          <div className={'col-sm-3 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.dateOfBirth} />
                            </PageSectionHeader>
                            <DatePicker
                              position={'bottom-start'}
                              disabled={isReadOnly}
                              name="dateOfBirthTravelCancellation"
                              type="text"
                              onDayChange={this.handleDayChange('form.dateOfBirthTravelCancellation')}
                              value={dateOfBirthTravelCancellation}
                            />
                          </div>
                          <div className={'col-sm-4 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.relationshipToClaimant} />
                            </PageSectionHeader>
                            <Textbox
                              name="relationshipToClaimantTravelCancellation"
                              type="text"
                              onChange={this.handleChange('form.relationshipToClaimantTravelCancellation')}
                              value={relationshipToClaimantTravelCancellation}
                              disabled={isReadOnly}
                            />
                          </div>
                        </div>
                        <div className={'ml-2 row'}>
                          <div className={'col-sm-4 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.dateSicknessOrInjuryBegan} />
                            </PageSectionHeader>
                            <DatePicker
                              position={'bottom-start'}
                              disabled={isReadOnly}
                              name="dateSicknessOrInjuryBeganTravelCancellation"
                              type="text"
                              onDayChange={this.handleDayChange('form.dateSicknessOrInjuryBeganTravelCancellation')}
                              value={dateSicknessOrInjuryBeganTravelCancellation}
                            />
                          </div>
                          <div className={'col-sm-4 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.dateEnded} />
                            </PageSectionHeader>
                            <DatePicker
                              position={'bottom-start'}
                              disabled={isReadOnly}
                              name="dateEndedTravelCancellation"
                              type="text"
                              onDayChange={this.handleDayChange('form.dateEndedTravelCancellation')}
                              value={dateEndedTravelCancellation}
                            />
                          </div>
                          <div className={'col-sm-4 form-group'}>
                          </div>
                        </div>
                        <div className={'ml-2 row'}>
                          <div className={'col-sm-12 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.natureOfSicknessOrInjury} />
                            </PageSectionHeader>
                            <TextArea
                              disabled={isReadOnly}
                              name="natureOfSicknessOrInjuryTravelCancellation"
                              type="text"
                              onChange={this.handleChange('form.natureOfSicknessOrInjuryTravelCancellation')}
                              value={natureOfSicknessOrInjuryTravelCancellation}
                              isSummary={isSummary}
                            />
                          </div>
                        </div>
                        <div className={'ml-2 row'}>
                          <div className={'col-sm-12 form-group'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.periodOfHospitalization} />
                            </PageSectionHeader>
                          </div>
                          <div className={'form-group col-sm-3'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.fromDate} />
                            </PageSectionHeader>
                            <DatePicker
                              position={'bottom-start'}
                              disabled={isReadOnly}
                              name="fromDateTravelCancellation"
                              type="text"
                              onDayChange={this.handleDayChange('form.fromDateTravelCancellation')}
                              value={fromDateTravelCancellation}
                            />
                          </div>
                          <div className={'form-group col-sm-3'}>
                            <PageSectionHeader>
                              <FormattedMessage {...messages.toDate} />
                            </PageSectionHeader>
                            <DatePicker
                              position={'bottom-start'}
                              disabled={isReadOnly}
                              name="toDateTravelCancellation"
                              type="text"
                              onDayChange={this.handleDayChange('form.toDateTravelCancellation')}
                              value={toDateTravelCancellation}
                            />
                          </div>
                          <div className={'form-group col-sm-6'}>
                          </div>
                        </div>
                        <div className={'ml-2 row'}>
                          <div className={'form-group col-sm-7'}>
                            <HelpText>
                              On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                            </HelpText>
                          </div>
                          <div className={'form-group col-sm-5'}>
                            <AsyncButtonSendMail
                              id={this.emailMeDocumentButton}
                              className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                              disabled={buttonEmailMeDisable || isReadOnly}
                              loading={this.props.loading}
                              spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                              onClick={this.handleEmailMeButtonClick}
                            >
                              Statement of Attending Physician
                            </AsyncButtonSendMail>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons3"
                      checked={reasonForTripCancellations.includes('reasons3')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons3} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons4"
                      checked={reasonForTripCancellations.includes('reasons4')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons4} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons5"
                      checked={reasonForTripCancellations.includes('reasons5')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons5} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons6"
                      checked={reasonForTripCancellations.includes('reasons6')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons6} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons7"
                      checked={reasonForTripCancellations.includes('reasons7')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons7} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons8"
                      checked={reasonForTripCancellations.includes('reasons8')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons8} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons9"
                      checked={reasonForTripCancellations.includes('reasons9')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons9} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons10"
                      checked={reasonForTripCancellations.includes('reasons10')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons10} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons11"
                      checked={reasonForTripCancellations.includes('reasons11')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons11} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons12"
                      checked={reasonForTripCancellations.includes('reasons12')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons12} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons13"
                      checked={reasonForTripCancellations.includes('reasons13')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons13} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons14"
                      checked={reasonForTripCancellations.includes('reasons14')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons14} />
                    </span>
                  </div>
                  <div className={'col-sm-12 form-group'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="reasons15"
                      checked={reasonForTripCancellations.includes('reasons15')}
                      onChange={this.handleReasonsForTripCancellation('form.reasonForTripCancellation')}
                    />
                    <span>
                      <FormattedMessage {...messages.reasons15} />
                    </span>
                    {isReason15 === true &&
                      <div className={'ml-2 row'}>
                        <div className={'col-sm-12 form-group'}>
                          <Validate
                            name="reasonForCancellation"
                            validators={[required]}
                            group={this.validatorGroup}
                            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                            validChangeInGroup={this.validatorGroup.validChangeInGroup}
                            validationCounter={this.state.validationCounter}
                            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                            defaultValue={reasonForTravelCancellation}
                            fieldName={messages.reasonForCancellation}
                          >
                            <TextArea
                              name="reasonForAirlineReissue"
                              type="text"
                              onChange={this.handleChange('form.reasonForTravelCancellation')}
                              value={reasonForTravelCancellation}
                              disabled={isReadOnly}
                            />
                            <ErrorMessage for="required">
                              <FormattedMessage
                                {...messages.isRequired}
                                values={messages.reasonForCancellation}
                              />
                            </ErrorMessage>
                          </Validate>
                        </div>
                      </div>
                    }
                  </div>
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.reasonsForTripCancellation}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
          }
          {newVersion &&
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="dateTravelCancellation"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateTravelCancellation}
                  fieldName={messages.dateTripWasCancelledWithTravelSupplier}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateTravelCancellation"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateTravelCancellation')}
                    value={dateTravelCancellation}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasCancelledWithTravelSupplier}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateTripWasCancelledWithTravelSupplier}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
              </div>
            </div>
          }
          {(isClaimGroupAllowed && !enabledClaimSplitFeature) &&
            <div className={'ml-3 row'}>
              <div className={'col-sm-12'}>
                <HelpText>
                  The amount you claim below is PER MEMBER. It needs to be an EQUAL amount claimed, for each person you selected in the page "What Happened".
                  If you want to claim DIFFERENT amounts for each person, please create a SEPARATE CLAIM per person.
                </HelpText>
              </div>
            </div>
          }
          <div className={'ml-3 mt-3'}>
            <PageSectionHeader>
              <FormattedMessage
                {...(isClaimGroupAllowed ? messages.lossInformationPerPerson : messages.lossInformation)}
              />
            </PageSectionHeader>
            {this.renderTravelCancellationAdditionalItems()}
            {!newVersion &&
              <div className={'ml-2 row'}>
                <div className={'col-sm-6 form-group'}>
                  <Validate
                    name="dateTravelCancellation"
                    validators={[checkDateOnly, required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={dateTravelCancellation}
                    fieldName={messages.dateTripWasCancelledWithTravelSupplier}
                  >
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateTravelCancellation"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateTravelCancellation')}
                      value={dateTravelCancellation}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.dateTripWasCancelledWithTravelSupplier}
                      />
                    </ErrorMessage>
                    <ErrorMessage for="checkDateOnly">
                      <FormattedMessage
                        {...messages.checkEventDate}
                        values={messages.dateTripWasCancelledWithTravelSupplier}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
                <div className={'col-sm-6 form-group'}>
                </div>
              </div>
            }
            {!newVersion &&
              <div className={'ml-2 row'}>
                <div className={'col-sm-12 form-group'}>
                  <Validate
                    name="reasonForCancellation"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={reasonForTravelCancellation}
                    fieldName={messages.reasonForCancellation}
                  >
                    <TextArea
                      name="reasonForAirlineReissue"
                      type="text"
                      onChange={this.handleChange('form.reasonForTravelCancellation')}
                      value={reasonForTravelCancellation}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.reasonForCancellation}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
              </div>
            }
            {!newVersion &&
              <div>
                <div className={'ml-2 row'}>
                  <div className={'col-sm-5 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.nameOfPersonHavingSickness} />
                    </PageSectionHeader>
                    <Textbox
                      name="nameOfPersonHavingSicknessTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.nameOfPersonHavingSicknessTravelCancellation')}
                      value={nameOfPersonHavingSicknessTravelCancellation}
                      disabled={isReadOnly}
                    />
                  </div>
                  <div className={'col-sm-3 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.dateOfBirth} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateOfBirthTravelCancellation"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateOfBirthTravelCancellation')}
                      value={dateOfBirthTravelCancellation}
                    />
                  </div>
                  <div className={'col-sm-4 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.relationshipToClaimant} />
                    </PageSectionHeader>
                    <Textbox
                      name="relationshipToClaimantTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.relationshipToClaimantTravelCancellation')}
                      value={relationshipToClaimantTravelCancellation}
                      disabled={isReadOnly}
                    />
                  </div>
                </div>
                <div className={'ml-2 row'}>
                  <div className={'col-sm-4 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.dateSicknessOrInjuryBegan} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateSicknessOrInjuryBeganTravelCancellation"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateSicknessOrInjuryBeganTravelCancellation')}
                      value={dateSicknessOrInjuryBeganTravelCancellation}
                    />
                  </div>
                  <div className={'col-sm-4 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.dateEnded} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateEndedTravelCancellation"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateEndedTravelCancellation')}
                      value={dateEndedTravelCancellation}
                    />
                  </div>
                  <div className={'col-sm-4 form-group'}>
                  </div>
                </div>
                <div className={'ml-2 row'}>
                  <div className={'col-sm-12 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.natureOfSicknessOrInjury} />
                    </PageSectionHeader>
                    <TextArea
                      disabled={isReadOnly}
                      name="natureOfSicknessOrInjuryTravelCancellation"
                      type="text"
                      onChange={this.handleChange('form.natureOfSicknessOrInjuryTravelCancellation')}
                      value={natureOfSicknessOrInjuryTravelCancellation}
                      isSummary={isSummary}
                    />
                  </div>
                </div>
                <div className={'ml-2 row'}>
                  <div className={'col-sm-12 form-group'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.periodOfHospitalization} />
                    </PageSectionHeader>
                  </div>
                  <div className={'form-group col-sm-3'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.fromDate} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="fromDateTravelCancellation"
                      type="text"
                      onDayChange={this.handleDayChange('form.fromDateTravelCancellation')}
                      value={fromDateTravelCancellation}
                    />
                  </div>
                  <div className={'form-group col-sm-3'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.toDate} />
                    </PageSectionHeader>
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="toDateTravelCancellation"
                      type="text"
                      onDayChange={this.handleDayChange('form.toDateTravelCancellation')}
                      value={toDateTravelCancellation}
                    />
                  </div>
                  <div className={'form-group col-sm-6'}>
                  </div>
                </div>
                <div className={'ml-2 row'}>
                  <div className={'form-group col-sm-7'}>
                    <HelpText>
                      On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                    </HelpText>
                  </div>
                  <div className={'form-group col-sm-5'}>
                    <AsyncButtonSendMail
                      id={this.emailMeDocumentButton}
                      className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                      disabled={buttonEmailMeDisable || isReadOnly}
                      loading={this.props.loading}
                      spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                      onClick={this.handleEmailMeButtonClick}
                    >
                      Statement of Attending Physician
                    </AsyncButtonSendMail>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      )
    );
  }

  // Trip Cancellation for Any Reason
  renderTripCancellationForAnyReason() {
    const {
      tripCancellationForAnyReason,
      areYouCancellingTheTripDueToMedicalReasonsForAnyReason,
      dateTripCancellationForAnyReason,
      reasonForTripCancellationForAnyReason,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, jsonVersion, isClaimGroupAllowed, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;
    const newVersion = jsonVersion > 7;
    const enabledClaimSplitFeature = jsonVersion >= 17 && isClaimForFieldEnabled;
    return (
      tripCancellationForAnyReason === 'true' && (
        <div>
          {!newVersion &&
            <div className={'ml-3 row'}>
              <div className={'col-sm-6 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.areYouCancellingTheTripDueToMedicalReasons} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="true"
                      checked={areYouCancellingTheTripDueToMedicalReasonsForAnyReason === 'true'}
                      onChange={this.handleChange('form.areYouCancellingTheTripDueToMedicalReasonsForAnyReason')}
                    />
                    <FormattedMessage {...messages.yes} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="false"
                      checked={areYouCancellingTheTripDueToMedicalReasonsForAnyReason === 'false'}
                      onChange={this.handleChange('form.areYouCancellingTheTripDueToMedicalReasonsForAnyReason')}
                    />
                    <FormattedMessage {...messages.no} />
                  </OptionsContainer>
                </FlexBox>
              </div>
            </div>
          }
          {!newVersion &&
            <div className={'ml-3'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.insureds} />
              </PageSectionHeader>
              {this.renderInsuredsTripCancellationForAnyReason()}
            </div>
          }
          {newVersion &&
            <div className={'ml-3'}>
              <div className={'row'}>
                <div className={'col-sm-6 form-group'}>
                  <Validate
                    name="dateTripCancellationForAnyReason"
                    validators={[checkDateOnly, required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={dateTripCancellationForAnyReason}
                    fieldName={messages.dateTripWasCancelledWithTravelSupplier}
                  >
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="dateTripCancellationForAnyReason"
                      type="text"
                      onDayChange={this.handleDayChange('form.dateTripCancellationForAnyReason')}
                      value={dateTripCancellationForAnyReason}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.dateTripWasCancelledWithTravelSupplier}
                      />
                    </ErrorMessage>
                    <ErrorMessage for="checkDateOnly">
                      <FormattedMessage
                        {...messages.checkEventDate}
                        values={messages.dateTripWasCancelledWithTravelSupplier}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
                <div className={'col-sm-6 form-group'}>
                </div>
              </div>
              <div className={'row'}>
                <div className={'col-sm-12 form-group'}>
                  <Validate
                    name="reasonForCancellation"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={reasonForTripCancellationForAnyReason}
                    fieldName={messages.reasonForCancellation}
                  >
                    <TextArea
                      name="reasonForAirlineReissue"
                      type="text"
                      onChange={this.handleChange('form.reasonForTripCancellationForAnyReason')}
                      value={reasonForTripCancellationForAnyReason}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.reasonForCancellation}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
              </div>
            </div>
          }
          {(isClaimGroupAllowed && !enabledClaimSplitFeature) &&
            <div className={'ml-3 row'}>
              <div className={'col-sm-12'}>
                <HelpText>
                  The amount you claim below is PER MEMBER. It needs to be an EQUAL amount claimed, for each person you selected in the page "What Happened".
                  If you want to claim DIFFERENT amounts for each person, please create a SEPARATE CLAIM per person.
                </HelpText>
              </div>
            </div>}
          <div className={'ml-3 mt-3'}>
            <PageSectionHeader>
              <FormattedMessage
                {...(isClaimGroupAllowed ? messages.lossInformationPerPerson : messages.lossInformation)}
              />
            </PageSectionHeader>
            {this.renderForAnyReasonInformationItems()}
            {!newVersion &&
              <div className={'ml-2'}>
                <div className={'row'}>
                  <div className={'col-sm-6 form-group'}>
                    <Validate
                      name="dateTripCancellationForAnyReason"
                      validators={[checkDateOnly, required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={dateTripCancellationForAnyReason}
                      fieldName={messages.dateTripWasCancelledWithTravelSupplier}
                    >
                      <DatePicker
                        position={'bottom-start'}
                        disabled={isReadOnly}
                        name="dateTripCancellationForAnyReason"
                        type="text"
                        onDayChange={this.handleDayChange('form.dateTripCancellationForAnyReason')}
                        value={dateTripCancellationForAnyReason}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.dateTripWasCancelledWithTravelSupplier}
                        />
                      </ErrorMessage>
                      <ErrorMessage for="checkDateOnly">
                        <FormattedMessage
                          {...messages.checkEventDate}
                          values={messages.dateTripWasCancelledWithTravelSupplier}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                  <div className={'col-sm-6 form-group'}>
                  </div>
                </div>
                <div className={'row'}>
                  <div className={'col-sm-12 form-group'}>
                    <Validate
                      name="reasonForCancellation"
                      validators={[required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={reasonForTripCancellationForAnyReason}
                      fieldName={messages.reasonForCancellation}
                    >
                      <TextArea
                        name="reasonForAirlineReissue"
                        type="text"
                        onChange={this.handleChange('form.reasonForTripCancellationForAnyReason')}
                        value={reasonForTripCancellationForAnyReason}
                        disabled={isReadOnly}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.reasonForCancellation}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      )
    );
  }

  render() {
    const {
      tripCancellation,
      tripCancellationForAnyReason,
      travelInterruption,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading } = this.props;
    const isRenderTravelCancellation = !!stepTripCancellationAndTripInterruptionExpenseLookup.tripCancellation.claimCode;
    const isRenderTripCancellationForAnyReason = !!stepTripCancellationAndTripInterruptionExpenseLookup.tripCancellationForAnyReason.claimCode;
    const isRenderTravelInterruption = !!stepTripCancellationAndTripInterruptionExpenseLookup.travelInterruption.claimCode;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        {isRenderTravelCancellation &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.tripCancellation} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={tripCancellation === 'true'}
                    onChange={this.handleChange('form.tripCancellation')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={tripCancellation === 'false'}
                    onChange={this.handleChange('form.tripCancellation')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {isRenderTravelCancellation && this.renderTripCancellation()}
        {isRenderTripCancellationForAnyReason &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.tripCancellationForAnyReason} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={tripCancellationForAnyReason === 'true'}
                    onChange={this.handleChange('form.tripCancellationForAnyReason')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={tripCancellationForAnyReason === 'false'}
                    onChange={this.handleChange('form.tripCancellationForAnyReason')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {isRenderTripCancellationForAnyReason && this.renderTripCancellationForAnyReason()}
        {isRenderTravelInterruption &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelInterruption} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={travelInterruption === 'true'}
                    onChange={this.handleChange('form.travelInterruption')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={travelInterruption === 'false'}
                    onChange={this.handleChange('form.travelInterruption')}
                    onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {isRenderTravelInterruption && this.renderTravelInterruption()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

StepTripCancellationAndTripInterruption.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormTravelInterruption: PropTypes.func,
  sendPhysicianEmail: PropTypes.func,
  sendPhysicianEmailInterruption: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  jsonVersion: PropTypes.string,
  isClaimGroupAllowed: PropTypes.bool,
  intl: intlShape.isRequired,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepTripCancellationAndTripInterruption(),
  errors: makeSelectStepTripCancellationAndTripInterruptionErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  jsonVersion: makeSelectJSONVersion(),
  isClaimGroupAllowed: makeSelectIsClaimGroupAllowed(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormTravelInterruption: () => dispatch(resetFormTravelInterruption()),
  onResetFormData: () => dispatch(resetFormData()),
  sendPhysicianEmail: () => dispatch(emailMedicalTravelDocument()),
  sendPhysicianEmailInterruption: () => dispatch(emailInterruptionDocument()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'stepTripCancellationAndTripInterruption', reducer });

export default compose(
  withReducer,
  withConnect,
  injectIntl
)(StepTripCancellationAndTripInterruption);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepTripCancellationAndTripInterruption/index.js